export default "__VITE_ASSET__DtoOjJkQ__"